import script from "./Header.vue?vue&type=script&lang=ts&setup=true"
export * from "./Header.vue?vue&type=script&lang=ts&setup=true"

import "./Header.vue?vue&type=style&index=0&id=fd15fb7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd15fb7c"]])

export default __exports__